import template from './departments_component.html';
import tr from '../../lib/default-translator.js';

class AdminDepartmentsComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.departments = ko.observableArray();
		this.companies = ko.observableArray();
		this.data = ko.observable();
		
		this.save_department = this.save_department.bind(this);
		this.delete_department = this.delete_department.bind(this);

		// PAGE LOAD
		let Department = (config) => {
			this.data($.extend({
				company: '',
				company_id: '',
				department: '',
				department_id: ''
			}, config));
	
			ko.mapping.fromJS(this.data(), {}, this);
		};

		this.init();
	}

	async updateData()
	{
		try {
			let options = {
				table: 'v_department_company',
				schema: 'savanna',
				limit: 1000000
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				if (res.records)
					this.departments(res.records);
			}
		} catch(error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		try {
			let options = {
				table: 'company',
				limit: 1000000,
				schema: 'public'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);

			if (res.status == 'OK')
			{
				if (res.records)
					this.companies(res.records);
			}
		} catch(error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
	};

	init()
	{
		this.updateData();
	};

	edit_department(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();
		view_row.hide();
		edit_row.show();
	};

	async delete_department(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', message: tr('Are you sure you want to delete this department entry ?'), title: tr('Warning')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/departments/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted department.'), title: tr('Success', 'Success')});
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	async save_department(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		if (data.department_id == '')
			data.department_id = null;

		let res = await Grape.fetches.postJSON('/admin/departments/edit', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully saved department.'), title: tr('Success')});
			this.updateData();
			edit_row.hide();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error')});
			this.updateData();
		}
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});

		view_row.show();
		edit_row.hide();
	};

	add_department(data)
	{
		let departments = data.departments;
		departments.unshift({
			'company': '',
			'company_id': '',
			'department': '',
			'department_id': ''
		});

		let row = $('#department_body > tr:first-child');
		row.hide();
		row.next().show();
	}

	cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		edit_row.hide();
		this.updateData();
	}
}

export default {
	name: 'departments_component',
	viewModel: AdminDepartmentsComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/departments_component'
};
